import { graphql, useStaticQuery } from 'gatsby';

export const useHoverConfig = () => {
	const data = useStaticQuery(graphql`
		query {
			contentstackHoverConfig {
				hover_cards {
					placement
					image {
						...Image
						image {
							url
							gatsbyImageData(quality: 90)
						}
					}
					badge
					heading
					subheading
					cta {
						...CTA
					}
					bullets {
						material_symbol
						file {
							url
							gatsbyImageData(quality: 90)
						}
						heading
					}
				}
			}
		}
	`);

	return data.contentstackHoverConfig;
};
